import { IInsuranceParams, Variant } from "."
import { RiskVariant, Selection } from "../enums"
import { StepBase } from "./StepBase"

export type InsuranceParamsPropertyDto = {
    property: Property
} & StepBase & IInsuranceParams

export interface Property {
    range: number
    type?: number
    spol?: number
    liability?: number
    responsibilityRealestate?: number
    insurers: number[]
    data: InsuranceParamsPropertyDataDto
    variants?: Variant[]
}

export const InitialPropertyValues: Property = {
    range: RiskVariant.MiniRange,
    //type: RiskVariant.HouseholdAndRealty, // nechtějí default
    spol: undefined,
    liability: undefined,
    insurers: [],
    data: {
        //realtyTypeId: Selection.Byt, // nechtějí default
        hasGarageOnDifferentLocation: false,
        bigRiskCompany: false,
        realty: {
            builtUpAreaBusiness: 0,
        } as any,
        secondaryRealties: []
    }
}

export interface InsuranceParamsPropertyDataDto {
    realtyTypeId?: number
    isDamaged?: boolean
    isRoofFlammable?: boolean
    hasNonresidentialPremises?: boolean
    hasBasement?: boolean
    address?: Address
    household?: HouseholdDto
    realty?: RealtyDto
    secondaryRealties?: SecondaryRealtyDto[]
    hasGarageOnDifferentLocation?: boolean
    garageAddress?: Address
    garageAtOtherLocationAmount?: number
    garageAtOtherLocationEquipmentAmount?: number
    floodOccurence?: number
    floodOccurence20Available?: boolean
    floodOccurence10?: number
    floodSafeAppartment?: boolean
    csobBaScoring?: boolean
    floodInsuranceRequired?: boolean
    propojistenostDto?: PropojistenostDto
    propertyRelationId?: number
    bigRiskCompany?: boolean
    propertyValorisationAgreement?: boolean
    insuranceInNewPrice?: boolean
    securityFireAlarm?: boolean
    securityWaterLeakage?: boolean
    securityBurglarAlarm?: boolean
    securityCentralSecurityDesk?: boolean
    spolVariantId?: number
    longTimeRent?: boolean
}

export interface Address {
    addressPoint?: number | null
    street: string
    withoutStreet: boolean
    streetNumber: string
    landRegistryNumber?: number
    houseNumber: string
    postCode: string
    postCodeCu: string
    city: string
    cityWithCityPart: string
    cityPart: string
    isCatastralNumber: boolean
    isOutsideUrbanArea: boolean
    isOutsideUrbanAreaAvailable: boolean
    catastralNumberList?: AddressKuSelection[]
    catastralAreaCode: string
    parcelNumber: string
    fullAddress: string
    isEvidenceNumber?: boolean
}

export interface AddressKuSelection {
    kod: string
    nazev: string
    selected: boolean
}

export interface HouseholdDto {
    livingArea?: number
    floor?: number
    isApartmentOnLastFloor?: boolean
    equipment?: number
    isPernamentlyInhabited?: boolean
    countOfDamages?: number
    amount?: number
    valuablesAmount?: number
    nonresidentialAmount?: number
    countOfPeople?: number
    apartmentNumber: string
    approvedYear?: number
    structuralType: number
    floorsCount?: number
    roofType: number
    isRoofResidential?: boolean
    owner: number
    amountSum: number
}

export interface RealtyDto {
    isDamaged?: boolean
    isRoofFlammable?: boolean
    apartmentNumber: string
    apartmentFloor?: number
    isApartmentOnLastFloor?: boolean
    floorsCount?: number
    isInFamilyHouse?: boolean
    isInBuiltUpArea?: boolean
    distanceFromBuildUpArea?: boolean
    wasDamagedByFlood?: boolean
    countOfFoold1?: number
    countOfFoold2?: number
    isApproved?: boolean
    approvedYear?: number
    builtUpArea?: number
    builtUpAreaBusiness?: number
    builtUpCadastralArea?: number
    otherArea?: number
    usefulArea?: number
    buildingFlammability: number
    structuralType: number
    owner: number
    apparmentType: number
    state: number
    basementArea: number
    structuralElement: number
    buildingType: number
    builtDate?: string
    wasReconstructed?: boolean
    reconstructionDate?: string
    finishState: number
    roofType: number
    isRoofResidential?: boolean
    atticArea?: number
    isPernamentlyInhabited?: boolean
    countOfDamages?: number
    realtyAmount?: number
    gardenFlora?: number
    usedBy?: number
    goodState?: boolean
    secondaryRealty?: boolean
    amountSum: number
}

export interface SecondaryRealtyDto {
    type?: number
    otherArea?: number
    usefulArea?: number
    secondaryRealtyAmount?: number
    description: string
    delete: boolean
}

export interface PropojistenostDto {
    enabled: boolean
    isApplicable: boolean
    contracts?: PropopjistenostSmlouvaDto[]
}

export interface PropopjistenostSmlouvaDto {
    insurerId: number
    contranctNumber: string
    insurerName: string
}

export type Step1PropertyWarning = {
    message: string
    isRecreationalProperty: boolean
    isAddressLocationCadastral: boolean
}
